import {Box, Grid, Typography} from '@yandex-delivery/blocks'
import {useFormContext} from '@yandex-delivery/form'
import React, {memo} from 'react'

import {Body, Header, IconNumber} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'

import {PointAddress} from '../../PointAddress/PointAddress'
import {PointContact} from '../../PointContact/PointContact'
import {PredefinedParcelSelect} from '../PredefinedParcelSelect/PredefinedParcelSelect'
import type {DestinationPointProps as Props} from '../types'
import * as classes from './DestinationPoint.classes'
import {useDestinationPoint} from './hooks'

export const DestinationPoint = memo<Props>(function DestinationPoint(props) {
  const {orderNumber, RemoveButtonComponent} = props
  const {watch} = useFormContext()
  const {names} = useDestinationPoint(props)

  return (
    <Grid data-e2e={`destination-point-${orderNumber}`} size="m" container>
      <Grid xs={12} item>
        <Header lead={<IconNumber number={orderNumber} variant="black" />} tail={RemoveButtonComponent}>
          {i18n('cargo.create.destinations.to', 'Куда')}
        </Header>
      </Grid>
      <Grid xs={12} item>
        <PointAddress data-testid="destinations_recipient_address" name={names.address} pointType="b" />
      </Grid>
      <Grid xs={12} item>
        <PointContact
          name={names.contact}
          pointType="b"
          title={i18n('cargo.create.destinations.recipient', 'Получатель')}
          isSmsConfirmationEnabled
        />
      </Grid>
      <Grid xs={12} item>
        <PredefinedParcelSelect data-testid={`parcels_${names.parcels}`} name={names.parcels} />
      </Grid>
      {watch('offerFlow.vertical.name') === 'walking_courier' && (
        <Body
          tail={
            <Grid className={classes.noteContainer} container>
              <Box className={classes.note}>
                <Typography group="tight" variant="body2">
                  {i18n('order.form.parcel.courier-note-title-text', 'Велокурьером можно отправить')}{' '}
                  <strong>{i18n('order.form.parcel.courier-note-title-load', 'до 10 кг')}</strong>
                </Typography>
                <Typography color="minor" group="tight" variant="caption1">
                  {i18n(
                    'order.form.parcel.courier-note-caption',
                    'Если ваша посылка больше – переключитесь на тариф Экспресс',
                  )}
                </Typography>
              </Box>
            </Grid>
          }
        />
      )}
    </Grid>
  )
})
